import { call, put, takeLatest } from 'redux-saga/effects';
import { getVehicleTypesRoutine } from '@modules/orders-and-trips/actions';
import { OrdersNTripsApi } from '@modules/orders-and-trips/api';

function* getVehicleTypesWorker() {
  const { request, success, failure, fulfill } = getVehicleTypesRoutine;
  try {
    yield put(request());
    const {
      data: { data }
    } = yield call(OrdersNTripsApi.getVehicleTypes);
    yield put(success({ data }));
  } catch (error) {
    yield put(failure({ error }));
  } finally {
    yield put(fulfill());
  }
}

export function* getVehicleTypesWatcher() {
  yield takeLatest(getVehicleTypesRoutine.trigger, getVehicleTypesWorker);
}
